module.exports = __webpack_public_path__ + "static/media/Purpose.6b06e04c.svg";